import { ApiService } from '../../services/restApiService'
import { ApiType, EncKeys } from '../../../config'
import CryptoJS from 'crypto-js'
export const SAVE_PAYMENT_REQUEST_DATA = 'SAVE_PAYMENT_REQUEST_DATA'
export const CLEAR_STATE = 'CLEAR_STATE'
export const SAVE_CARD_DATA = 'SAVE_CARD_DATA'
export const DELETE_CARD = 'DELETE_CARD'

const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)

export const getPaymentRequestData =
    (data, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/banking/getCustomerRequestData',
                data,
                'post'
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                    if (result.data.statusCode === 200) {
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            result.data.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                        let actualResponse = JSON.parse(decrypted)
                        dispatch({
                            type: SAVE_PAYMENT_REQUEST_DATA,
                            payload: actualResponse,
                        })
                    }
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }

export const deleteCard =
    (data, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/payment/DeleteSavedCard',
                data,
                'post'
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }
export const getTransactionStatus =
    (data, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/transaction/getTransactionStatus',
                data,
                'post'
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }

export const getCreditCustomerLimitDetail =
    (data, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/banking/CustomerCreditLimitDetail',
                data,
                'post'
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }

export const VTapPayment =
    (data, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/payment/VTapPayment',
                data,
                'post'
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }

export const createPaymentRequestData =
    (payLoad, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/payment/CreatePaymentRequest',
                payLoad,
                'post'
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }
export const checkVPA =
    (payLoad, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/UPI/CheckVPA',
                payLoad,
                'post'
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }
export const generateOTP =
    (payLoad, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/OTP/GenerateOTP',
                payLoad,
                'post',
                false
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }
export const verifyOTP =
    (payLoad, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/OTP/VerifyOTP',
                payLoad,
                'post',
                false
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }
export const processCancelledTransaction =
    (payLoad, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/payment/processCancelledTransaction',
                payLoad,
                'post'
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }
export const getSavedCardDetailByClientID =
    (payLoad, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/payment/GetSavedCardDetailByClientID',
                payLoad,
                'post'
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }
export const getPaymentResponse =
    (data, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/payment/ProcessPaymentResponse',
                data,
                'post'
            )
            .then((result) => {
                if (result && result.data) {
                    callback && callback(result.data)
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }

    export const calculateTransactionCharges =
    (data, callback, errorCallBack) => async (dispatch) => {
        new ApiService(true)
            .restCall(
                ApiType.baseApiUrl,
                'api/banking/CalculateTransactionCharges',
                data,
                'post'
            )
            .then((result) => {
                if (result && result.data) {
                    if (result.data.statusCode === 200) {
                                            callback && callback(result.data)
                    }
                }
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error)
            })
    }
